import React, { Component, Fragment } from 'react';

// components
import Button from '../common/button';
import Event from '../event';

// actions
import { getEvents } from '../../actions';

// style
import './style.scss';

class EventList extends Component {
  state = {
    events: [],
    loading: true
  };

  componentDidMount() {
    getEvents().then(res => {
      this.setState({
        events: res,
        loading: false
      });
    });

    window.addEventListener('scroll', this.updateImage);
  }

  // clean up after ya self
  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateImage);
  }

  updateImage = () => {
    const percent = this.getHeightPercentage(this.bgImage);

    if (percent > 20) return;
    if (percent < 0) return;

    this.bgImage.style.margin = `2rem ${percent}%`;
  };

  getHeightPercentage = ref => {
    const fromTop = ref.getBoundingClientRect().top,
      height = window.innerHeight,
      diff = fromTop - height,
      percent = (diff / height) * 100,
      formatted = percent + 60;

    if (formatted > 20) return 20;
    if (formatted < 0) return 0;

    return formatted;
  };

  render() {
    const { events } = this.state;

    return (
      <div className="events" ref={rf => (this.bgImage = rf)}>
        {events &&
          events.length > 0 && (
            <Fragment>
              <div className="events__bg" />
              <h4 className="events__title">Food Lineup</h4>
              <div className="events__list">
                {events.map(event => {
                  return (
                    <Event
                      key={event.id}
                      data={event.data}
                      vendor={event.vendor.data}
                      icon={event.vendor.icon}
                      slug={event.slug}
                    />
                  );
                })}
              </div>
            </Fragment>
          )}

        <div className="byof">
          <h4 className="heading heading--medium brown">BYOF</h4>
          <p style={{ textAlign: 'center' }}>
            Don’t see anything you like? Feel free to bring your own food or
            have food delivered.
          </p>
          <Button type="link" action="/faq">
            Brewery FAQs
          </Button>
        </div>
      </div>
    );
  }
}

export default EventList;



// WEBPACK FOOTER //
// ./src/components/event-list/index.js